import React from 'react'
import {connect} from 'react-redux'

import Modal from '../common/components/Modal'
import * as feedbackActions from '../feedback/actions'
import { messages } from "../chatItemGenerator"

const ExplanationModal = ({ show, explanation, heading, closeModal }) =>
  show ? (
    <Modal
      heading={heading || <span>Why am I being asked this?</span>}
      body={explanation}
      buttonClick={closeModal}
      cancelClick={closeModal}
      buttonText={messages.identifiersSexWhyOkay} // turn this into a buttonText prop later
    />
  ) : (
    <span />
  )

const generateMessage = (explanation) => {
  // handle hardcoded messaging for age and sex.
  if (explanation && explanation.text) {
    return explanation.text
  }

  if (!(explanation && explanation.diagnosis)) {
    return "This question could rule out one of our leading explanations for your symptoms."
  }

  let {diagnosis, predictors} = explanation
  let message = `This question is about ${diagnosis}`
  if (predictors.length > 0)
    message += `, which can cause your ${predictors[0]}`
  if (predictors.length > 1)
    message += ` and ${predictors[1]}`
  message += ', among other things.'
  return message
}

const mapStateToProps = (state) => ({
  show: !!state.feedback.explanation,
  explanation: generateMessage(state.feedback.explanation),
  heading: state.feedback.explanation && state.feedback.explanation.heading,
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(feedbackActions.setExplanation(null))
})

const ExplanationModalContainer = connect(mapStateToProps, mapDispatchToProps)(ExplanationModal)

export {ExplanationModalContainer as default, ExplanationModal}



// WEBPACK FOOTER //
// ./assets/modals/ExplanationModal.js